import { Cross } from './Cross';

export type { TypeCrossProps } from './types';
export default Cross;
